import { Box } from '@atom-web/micros'
import moment from 'moment'
import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'

import dateUtils from '../../utils/dateUtils'
import isMountStatus from '../../utils/isMountStatus'
import { DEPARTURE_DATE_CHANGED, SET_ENABLE_GET_COST } from './Constants'
import GCMContext from './GCMContext'
import CalendarPicker from './macros/CalendarPicker'
// import getGCMDefaultData from '../utils/getGCMDefaultData';

const DATE_UTILS = dateUtils()

const getDateString = date => {
	const dateFormat = DATE_UTILS.getDateFormat(date.replace(/\//g, '-'))
	/**Firfox date fix ex. new Date('12-Sep-2020') -> Date Fri Sep 12 -2020 00:00:00 GMT+0553 (India Standard Time)
	 *  because of (-) in the year leads to invalid date
	 **/
	return /^-/.test(dateFormat) ? dateFormat.replace(/-/, '') : dateFormat
}

const DepartureDate = ({
	itineraryInfo,
	onChange,
	minDate,
	maxDate,
	disabledDates,
	availableDates = [],
	selectedDate: dateSelected,
	getDateSubText,
	selectNextRange,
	isLoggedIn,
	defaultDate = 1,
}) => {
	const [{ departureDate }, dispatch] = useContext(GCMContext)
	const [selectedDate, setSelectedDate] = useState(
		departureDate || dateSelected,
	)

	const router = useRouter()
	const isMount = isMountStatus()

	const onDepartureDateChange = value => {
		dispatch({
			type: DEPARTURE_DATE_CHANGED,
			payload: {
				departureDate: moment(value).format('DD/MMM/YYYY'),
			},
		})
		dispatch({
			type: SET_ENABLE_GET_COST,
			payload: { itineraryInfo, isLoggedIn },
		})
		typeof onChange === 'function' &&
			onChange(moment(value, 'DD/MMM/YYYY').format('DD-MMM-YYYY'))
	}

	useEffect(() => {
		if (isMount) {
			const q = router.params
			// if (
			//   departureAirport === '$$$' ||
			//   (typeof q?.da === 'string' && q?.da === '$$$')
			// ) {
			//   setHeaderCopy('When are you arriving?');
			// }
			// set selected date if it is available in query string
			if (typeof q?.dd === 'string') {
				setSelectedDate(moment(q?.dd, 'DD-MMM-YYYY').format('DD/MMM/YYYY'))
			}
			// } else {
			//   if (!departureDate) {
			//     dispatch({
			//       type: COSTING_INFO,
			//       payload: getGCMDefaultData(itineraryInfo)
			//     });
			//   }
		}
	}, [departureDate])

	return (
		<Box
			css={{
				paddingTop: '40px',
			}}
		>
			<CalendarPicker
				minDate={minDate || DATE_UTILS.addDay(new Date(), 1)}
				maxDate={maxDate || DATE_UTILS.addMonth(new Date(), 9)}
				disabledDates={disabledDates || []}
				availableDates={availableDates || []}
				selectedDate={
					typeof departureDate === 'string'
						? new Date(getDateString(departureDate))
						: selectedDate
						? new Date(selectedDate)
						: departureDate || DATE_UTILS.addDay(new Date(), defaultDate)
				}
				onSelect={onDepartureDateChange}
				getDateSubText={getDateSubText}
				selectNextRange={selectNextRange}
			/>
		</Box>
	)
}

export default DepartureDate
